
import React from 'react';
import { Language, AgentProfile } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface RobotHeaderProps {
  language: Language;
  activeAgent: AgentProfile;
  isActive: boolean;
  hasApiAccess: boolean;
  activeTab: 'agents' | 'visual' | 'options';
  onBack: () => void;
  onSetActiveTab: (tab: 'agents' | 'visual' | 'options') => void;
  isRtl: boolean;
}

const RobotHeader: React.FC<RobotHeaderProps> = ({ 
  language, activeAgent, isActive, hasApiAccess, activeTab, onBack, onSetActiveTab, isRtl 
}) => {
  const t = TRANSLATIONS[language];

  return (
    <div className="absolute top-0 left-0 right-0 h-16 lg:h-20 bg-white/90 dark:bg-[#0a0a0c]/90 backdrop-blur-md border-b border-slate-200 dark:border-white/5 flex items-center justify-between px-4 lg:px-8 z-50">
       <div className="flex items-center gap-4 lg:gap-6">
          <button onClick={onBack} className="w-10 h-10 rounded-xl hover:bg-slate-100 dark:hover:bg-white/5 flex items-center justify-center text-slate-500 transition-colors z-50 relative pointer-events-auto">
             <i className={`fas fa-arrow-${isRtl ? 'right' : 'left'}`}></i>
          </button>
          <div className={`w-2.5 h-2.5 lg:w-3 lg:h-3 rounded-full shadow-[0_0_10px_currentColor] ${isActive ? 'text-emerald-500 bg-emerald-500 animate-pulse' : 'text-red-500 bg-red-500'}`}></div>
          <div>
             <h2 className="text-xs lg:text-base font-black tracking-widest uppercase text-slate-800 dark:text-white flex items-center gap-2">
               {t.robotTitle} 
               {hasApiAccess && <span className="text-[9px] lg:text-[10px] bg-emerald-500/10 text-emerald-500 px-1.5 lg:px-2 py-0.5 rounded">API ENABLED</span>}
             </h2>
             <p className="text-[10px] lg:text-xs text-slate-400 font-mono hidden sm:block mt-0.5">ID: {activeAgent.id.substring(0,8)} • {activeAgent.role}</p>
          </div>
       </div>
       {/* Mobile Tab Toggles */}
       <div className="lg:hidden flex bg-slate-100 dark:bg-white/5 rounded-xl p-1">
          <button onClick={() => onSetActiveTab('agents')} className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all ${activeTab === 'agents' ? 'bg-white dark:bg-white/10 text-emerald-500 shadow-sm' : 'text-slate-400'}`}><i className="fas fa-users"></i></button>
          <button onClick={() => onSetActiveTab('visual')} className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all ${activeTab === 'visual' ? 'bg-white dark:bg-white/10 text-emerald-500 shadow-sm' : 'text-slate-400'}`}><i className="fas fa-eye"></i></button>
          <button onClick={() => onSetActiveTab('options')} className={`px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all ${activeTab === 'options' ? 'bg-white dark:bg-white/10 text-emerald-500 shadow-sm' : 'text-slate-400'}`}><i className="fas fa-sliders"></i></button>
       </div>
    </div>
  );
};
export default RobotHeader;
